import PropTypes from "prop-types";
import React, { useState } from "react";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";

import FormInputError from "../formInputGroups/FormInputError";
import FormInputLabel from "../formInputGroups/FormInputLabel";

function Select(props) {
  const {
    className,
    classNamePrefix,
    creatable,
    label,
    name,
    formik,
    options,
    placeholder,
    required,
    isDisabled,
    changeHandler,
    defaultValue,
    value,
    ...rest
  } = props;
  const [inputValue, setInputValue] = useState("");

  const components = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        const { value } = event.target;
        const currentValues = formik.values;
        const previousValue = currentValues[name];

        const updatedValue = [...previousValue, createOption(value)];

        formik?.setFieldValue(name, updatedValue);
        setInputValue("");
        event.preventDefault();
    }
  };
  return (
    <>
      {label && <FormInputLabel formLabel={label} required={required} />}
      {creatable ? (
        <CreatableSelect
          components={components}
          inputValue={inputValue}
          isClearable
          isMulti
          menuIsOpen={false}
          onChange={(newValue) => {
            formik?.setFieldValue(name, newValue);
          }}
          onInputChange={(newValue) => setInputValue(newValue)}
          onKeyDown={(e) => {
            handleKeyDown(e);
          }}
          placeholder="Type tags name and press enter..."
          value={value}
        />
      ) : (
        <ReactSelect
          className={`rjs-select ${className}`}
          classNamePrefix={`${classNamePrefix} form-select`}
          // classNamePrefix="form-select"
          placeholder={placeholder}
          isDisabled={isDisabled}
          name={name}
          defaultValue={defaultValue}
          options={options}
          onChange={
            changeHandler
              ? changeHandler
              : (e) => {
                  formik?.setFieldValue(name, e.value);
                }
          }
          value={value}
          {...rest}
        />
      )}
      <FormInputError formik={formik} name={name} />
    </>
  );
}

export const defaultProps = {
  className: "",
  classNamePrefix: "",
  creatable: false,
};

const optionShape = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isMulti: PropTypes.bool,
  creatable: PropTypes.bool,
  defaultValue: PropTypes.shape(optionShape),
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)),
  onChange: PropTypes.func,
  value: PropTypes.shape(optionShape),
  formik: PropTypes.object.isRequired,
  changeHandler: PropTypes.func,
  required: PropTypes.bool,
};

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default Select;
